<style scoped lang="scss" type="text/scss">
    .plain-block-container {
        box-sizing: border-box;
        padding: 1rem;
        background-color: #F4F4F4;
        border-radius: .15rem;
        font-size: .9rem;
        color: #888;
    }
</style>

<template>
    <div class="plain-block-container">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: '',
        data () {
            return {};
        }
    };
</script>
